import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ExpiringCoachRenewalContent} from './ExpiringCoachRenewalContent';
import reportPayload from './reportPayload';

export const ExpiringCoachRenewalReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Expiring Coach Renewals')}
      description={tt(
        'description',
        "Reach out to these Coaches to remind them that their businesses will expire if they don't renew.",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ExpiringCoachRenewalContent}
    />
  );
};

export default withHOC(
  withTranslation('report.allExpiringCoachRenewals'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL,
    popoverContentProps: {},
  }),
)(ExpiringCoachRenewalReport);
